import { __awaiter } from "tslib";
import Vue from 'vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import { adductionToStep } from '@/components/pages/spotPage/trade/helpers';
import { tradeDataCommonFilters } from '@/components/pages/spotPage/trade/mixins/filtersMixin';
let quoteSliderMultiplier = 1;
const getQuoteAssetSliderMultiplier = (vm) => {
    if (vm.tradeData.quoteAsset.stepSize >= 1)
        return 1;
    if (vm.tradeData.quoteAsset.stepSize.toString().includes('e')) {
        return Math.pow(10, Math.abs(+vm.tradeData.quoteAsset.stepSize.toString().split('e')[1]));
    }
    return Math.pow(10, vm.tradeData.quoteAsset.stepSize.toString().split('.')[1].length);
};
const getStepSizeLength = (vm, assetType) => {
    const step = vm.tradeData[assetType].stepSize;
    if (step >= 1)
        return 1;
    if (step.toString().includes('e'))
        return Math.abs(step.toString().split('e')[1]);
    return step.toString().split('.')[1].length;
};
function setBaseAssetFilter(vm) {
    vm.form.fields.base.maskConfig.digits = getStepSizeLength(vm, 'baseAsset');
    vm.form.fields.base.maskConfig.min = 0;
    vm.form.fields.base.value = adductionToStep(parseFloat(vm.tradeData.baseAsset.min), parseFloat(vm.tradeData.baseAsset.stepSize));
}
function setQuoteAssetFilter(vm) {
    vm.form.fields.quote.maskConfig.digits = getStepSizeLength(vm, 'quoteAsset');
    vm.form.fields.quote.maskConfig.min = 0;
    vm.form.fields.quote.value = adductionToStep(vm.tradeData.quoteAsset.min, parseFloat(vm.tradeData.quoteAsset.stepSize));
}
// let isSliderChange = false
export default Vue.extend({
    name: 'spotBuyWidget',
    mixins: [tradeDataCommonFilters],
    props: {
        tradeData: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        form: {
            valid: false,
            orderIsSend: false,
            fields: {
                base: {
                    value: '',
                    rules: [],
                    touched: false,
                    stepSize: '0.1',
                    maskConfig: {
                        alias: 'numeric',
                        allowMinus: false,
                        digits: 2,
                        min: 0,
                        max: Infinity
                    }
                },
                quote: {
                    value: '0.01',
                    rules: [],
                    touched: false,
                    maskConfig: {
                        alias: 'numeric',
                        allowMinus: false,
                        digits: 2,
                        min: 0,
                        max: Infinity
                    }
                }
            }
        }
    }),
    computed: {
        isInactive() {
            const vm = this;
            return vm.tradeData.quoteAsset.quantity < vm.tradeData.quoteAsset.min;
        },
        quoteSliderValue: {
            get() {
                const vm = this;
                const parsedValue = parseFloat(vm.form.fields.quote.value);
                if (!parsedValue)
                    return vm.tradeData.quoteAsset.min * quoteSliderMultiplier;
                if (parsedValue < vm.tradeData.quoteAsset.min)
                    return vm.tradeData.quoteAsset.min * quoteSliderMultiplier;
                if (parsedValue > vm.tradeData.quoteAsset.max)
                    return vm.tradeData.quoteAsset.max * quoteSliderMultiplier;
                return Math.trunc(parsedValue * quoteSliderMultiplier);
            },
            set(newValue) {
                const vm = this;
                // isSliderChange = true
                vm.form.fields.quote.touched = true;
                vm.form.fields.quote.value = (newValue / quoteSliderMultiplier).toString();
            }
        },
        quoteSliderMin() {
            const vm = this;
            const min = parseFloat(vm.tradeData.quoteAsset.min);
            const step = parseFloat(vm.tradeData.quoteAsset.stepSize);
            const adductedMin = adductionToStep(min, step);
            const result = (adductedMin >= 0 ? adductedMin : min) * quoteSliderMultiplier;
            return Math.trunc(result) + (step * quoteSliderMultiplier);
        },
        quoteSliderMax() {
            const vm = this;
            const max = parseFloat(vm.tradeData.quoteAsset.max);
            const step = parseFloat(vm.tradeData.quoteAsset.stepSize);
            const adductedMax = adductionToStep(max, step);
            const result = (adductedMax > 0 ? adductedMax : max) * quoteSliderMultiplier;
            return Math.trunc(result);
        }
    },
    watch: {
        'tradeData.baseAsset': {
            handler() {
                const vm = this;
                vm.form.fields.base.touched = false;
                vm.form.fields.quote.touched = false;
                setBaseAssetFilter(vm);
            },
            deep: true
        },
        'tradeData.quoteAsset': {
            handler() {
                const vm = this;
                vm.form.fields.base.touched = false;
                vm.form.fields.quote.touched = false;
                setQuoteAssetFilter(vm);
                quoteSliderMultiplier = getQuoteAssetSliderMultiplier(vm);
            },
            deep: true
        },
        'form.fields.base.touched'(v) {
            const vm = this;
            if (v) {
                vm.form.fields.base.rules = [
                    (v) => v >= vm.tradeData.baseAsset.min || `${vm.$t('spotPage.aside.widgets.minimum')} ${vm.tradeData.baseAsset.min} ${vm.tradeData.baseAsset.name}`,
                    (v) => v <= vm.tradeData.baseAsset.max || `${vm.$t('spotPage.aside.widgets.maximum')} ${vm.tradeData.baseAsset.max} ${vm.tradeData.baseAsset.name}`,
                    (v) => {
                        const preParsed = vm.tradeData.isNotReversedPair
                            ? parseFloat(vm.tradeData.currentSymbolPrice) * parseFloat(v + '')
                            : 1 * parseFloat(v + '') / (parseFloat(vm.tradeData.currentSymbolPrice));
                        return preParsed <= vm.tradeData.quoteAsset.max || `${vm.$t('spotPage.aside.widgets.notEnough')} ${vm.tradeData.quoteAsset.name}`;
                    }
                ];
            }
            else {
                vm.form.fields.base.rules = [];
            }
        },
        'form.fields.quote.touched'(v) {
            const vm = this;
            if (v) {
                vm.form.fields.quote.rules = [
                    (v) => v >= vm.tradeData.quoteAsset.min || `${vm.$t('spotPage.aside.widgets.minimum')} ${vm.tradeData.quoteAsset.min} ${vm.tradeData.quoteAsset.name}`,
                    (v) => v <= vm.tradeData.quoteAsset.max || `Доступно ${vm.tradeData.quoteAsset.max} ${vm.tradeData.quoteAsset.name}`
                ];
            }
            else {
                vm.form.fields.quote.rules = [];
            }
        },
        'form.fields.base.value'(v) {
            const vm = this;
            // const { baseAsset } = vm.$refs
            const parsedVal = vm.tradeData.isNotReversedPair
                ? parseFloat(vm.tradeData.currentSymbolPrice) * parseFloat(v)
                : 1 * parseFloat(v) / (parseFloat(vm.tradeData.currentSymbolPrice));
            // Была проверка if(baseAsset.isFocused). Удалить коментарий после прохождения тестов
            if (v) {
                if (parsedVal < vm.tradeData.quoteAsset.min) {
                    vm.form.fields.quote.value = vm.tradeData.quoteAsset.min;
                }
                else {
                    vm.form.fields.quote.value = parsedVal;
                }
            }
            else {
                vm.form.fields.quote.value = vm.tradeData.quoteAsset.min;
            }
        },
        'form.fields.quote.value'(v) {
            const vm = this;
            // const { quoteAsset } = vm.$refs
            const parsedVal = vm.tradeData.isNotReversedPair
                ? 1 / (parseFloat(vm.tradeData.currentSymbolPrice) / parseFloat(v))
                : (parseFloat(vm.tradeData.currentSymbolPrice) * parseFloat(v));
            if (v) {
                if (parsedVal < vm.tradeData.baseAsset.min) {
                    vm.form.fields.base.value = vm.tradeData.baseAsset.min;
                }
                else {
                    vm.form.fields.base.value = parsedVal;
                }
            }
            else {
                vm.form.fields.base.value = vm.tradeData.baseAsset.min;
            }
            // isSliderChange = false
        }
    },
    methods: {
        inputBaseValueHandler(value) {
            const vm = this;
            vm.form.fields.base.touched = true;
            vm.form.fields.base.value = value;
        },
        handleSubmit() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.form.orderIsSend = true;
                const response = yield vm.services.mainService.tradeOrderSpot({
                    quantity: adductionToStep(vm.form.fields.base.value, vm.tradeData.baseAsset.stepSize),
                    baseAsset: vm.tradeData.baseAsset.name,
                    quoteAsset: vm.tradeData.quoteAsset.name,
                    side: 'BUY'
                });
                if (response.success) {
                    if (!response.data.fail.length) {
                        vm.$store.dispatch('alertsBus/openAlert', {
                            title: vm.$t('spotPage.alerts.titles.success'),
                            type: 'success',
                            autoDelete: true,
                            content: vm.$t('spotPage.alerts.content.orderExecuted', { value: adductionToStep(vm.form.fields.base.value, vm.tradeData.baseAsset.stepSize), name: vm.tradeData.baseAsset.name })
                        });
                        vm.$emit('onSuccessTransaction');
                    }
                    else {
                        let errorContent = '';
                        if (response === null || response === void 0 ? void 0 : response.data.fail) {
                            errorContent = response.data.fail.reduce((arr, curr) => arr + '\n' + curr, '');
                        }
                        else if (response === null || response === void 0 ? void 0 : response.data.errors) {
                            errorContent = response.data.errors.reduce((arr, curr) => arr + '\n' + curr, '');
                        }
                        else {
                            errorContent = vm.$t('spotPage.alerts.content.errorHasOccurred');
                        }
                        vm.$store.dispatch('alertsBus/openAlert', {
                            title: vm.$t('spotPage.alerts.titles.operationFailed'),
                            type: 'error',
                            autoDelete: true,
                            content: errorContent
                        });
                    }
                }
                else {
                    let errorContent = '';
                    if (response === null || response === void 0 ? void 0 : response.data.errors) {
                        errorContent = response.data.errors.reduce((arr, curr) => arr + '\n' + curr, '');
                    }
                    else {
                        errorContent = vm.$t('spotPage.alerts.content.innerErrorOccurred');
                    }
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: errorContent
                    });
                }
                vm.form.orderIsSend = false;
            });
        },
        setSliderValuePercent(index) {
            const vm = this;
            const trueVal = 100 / 4 * (index - 1) / 100;
            setTimeout(() => {
                vm.quoteSliderValue = ((vm.quoteSliderMax - vm.quoteSliderMin) * trueVal + vm.quoteSliderMin);
            }, 0);
        },
        handleClickSetAll() {
            const vm = this;
            vm.form.fields.quote.touched = true;
            vm.form.fields.quote.value = vm.tradeData.quoteAsset.max;
        },
        handleChangeQuote(item) {
            const vm = this;
            if (item.value !== vm.tradeData.quoteAsset.name) {
                vm.form.fields.quote.value = '';
                vm.$emit('onChangeQuote', item.value);
            }
        }
    },
    mounted() {
        const vm = this;
        setBaseAssetFilter(vm);
        setQuoteAssetFilter(vm);
        quoteSliderMultiplier = getQuoteAssetSliderMultiplier(vm);
    },
    components: {
        VueSlider
    }
});
